import axionIns from "../axios";

const updatePassword = async (payload) => {
  return axionIns.post("user/update-password", JSON.stringify(payload)).then((response) => { return response.data });
};

const getProfile = async () => {
  return axionIns.get("user/me").then((response) => { return response.data });
};

const updateProfile = async (payload) => {
  return axionIns.put("user", JSON.stringify(payload)).then((response) => { return response.data });
};

const getActivity = async () => {
  return axionIns.get("user/activity").then((response) => { return response.data });
};

const loginAdminAsuser = async (payload) => {
  return axionIns.post("/admin/logadminasuser", JSON.stringify(payload)).then((response) => { return response.data });
};

const getAllUserList = async () => {
  return axionIns.get("/admin/alluserlist").then((response) => { return response.data });
};


const getUserListing = async (page, perPage, search) => {
  return axionIns.get(`admin/userlist?page=${page}&perPage=${perPage}&search=${search}`).then((response) => {
    return response.data;
  });
};

const makeAdvisor = async (id, payload) => {
  return axionIns.put(`admin/${payload?.isAdvisor ? 'enableadvisor' : 'disableadvisor'}/${id}`).then((response) => {
    return response.data;
  });
};

const reactiveUser = async (payload) => {
  return axionIns.post(`admin/reactiveUser`, payload).then((response) => {
    return response.data;
  });
};

const approveDeactivateUser = async (payload) => {
  return axionIns.post(`admin/approveDeactivateUser`, payload).then((response) => {
    return response.data;
  });
};

const deleteUser = async (id) => {
  return axionIns.delete(`admin/user/${id}`).then((response) => {
    return response.data;
  });
};

export default {
  updatePassword,
  getProfile,
  updateProfile,
  getActivity,
  loginAdminAsuser,
  getAllUserList,
  getUserListing,
  makeAdvisor,
  reactiveUser,
  approveDeactivateUser,
  deleteUser
};
